export const TYPE_LABEL = {
  parcel: '택배',
  combined: '묶음배송',
  quick: '퀵 배송',
  visit: '방문수령',
  partition: '개별배송',
};

export const TYPE = {
  parcel: 'parcel',
  combined: 'combined',
  quick: 'quick',
  visit: 'visit',
  partition: 'partition',
};

export const EXPRESS_SERVICE_DEFAULT_NAME = 'DEFAULT SERVICE';

export const COUNTY_ID_JP = 110;
export const COUNTY_CODE_JP = 'JP';

export const DEFAULT_SHIPPING_COMPANY_FOR_JP = 'lotte_economy_jp';

export const REQUIRED_CLEARANCE_NO_COUNTRIES = [
  {
    code: 'TW',
    name: 'Taiwan',
    type: 'ID',
    placeHolder: 'ID (e.g. A123456780)',
  },
  {
    code: 'CN',
    name: 'China',
    type: 'ID',
    placeHolder: 'ID (e.g. 110000199901019998)',
  },
  {
    code: 'MX',
    name: 'Mexico',
    type: 'ID',
    placeHolder: 'ID (e.g. MEXX990101HDFXXX09)',
  },
  {
    code: 'ID',
    name: 'Indonesia',
    type: 'Number',
    placeHolder: 'TAX ID (e.g. 3201010101010001)',
  },
  {
    code: 'BR',
    name: 'Brazil',
    type: 'CPF',
    placeHolder: 'CPF (e.g. 123.456.789-00)',
  },
];
